module.exports = __webpack_public_path__ + "img/snb_kangwonland.a538fcfc.svg";